import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { IAssetListItem } from '@features/assets/components/asset-card/asset-list-item.types';
import { AssetCard } from '@features/assets/components/asset-card/asset-card';

/** "Sličan sadržaj" tab — binge/similar items as a 3-column grid. Clicking one re-opens details. */
@Component({
    selector: 'details-vod',
    standalone: true,
    imports: [AssetCard],
    template: `
        <div class="grid grid-cols-3 gap-4">
            @for (item of items(); track item.referenceId) {
                <asset-card [item]="item" displayFormat="landscape"
                    (openDetails)="openItem.emit($event)"></asset-card>
            }
        </div>
    `,
    // asset-card carries fixed carousel dimensions (293px wide). Inside the modal's 3-column
    // grid we want each card to fill its cell instead, keeping the landscape 16:9 ratio.
    styles: [`
        :host ::ng-deep asset-card {
            width: 100% !important;
            height: auto !important;
            aspect-ratio: 16 / 9;
            margin-right: 0 !important;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsVod {
    readonly items = input.required<readonly IAssetListItem[]>();

    readonly openItem = output<IAssetListItem>();
}
